import React from 'react';
import Typography from '@material-ui/core/Typography';

const NotFound: React.FC = () => {

  return (
    <>
      <Typography variant="h1">
        Not found
      </Typography>
      <p>
        There is nothing here. Try going through the <a href="/">front door</a>.
      </p>
    </>
  );
};
export default NotFound;
